module.exports = __webpack_public_path__ + "quanthum.ee143ccd757fb8ef1c83.ttf";


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/assets/vcg/css/fonts/quanthum/quanthum.ttf?8kbwol
// module id = ../../../../../src/assets/vcg/css/fonts/quanthum/quanthum.ttf?8kbwol
// module chunks = styles